import AnchorButton, { AnchorButtonProps } from "../AnchorButton/AnchorButton";

import LinkButton from "../LinkButton";
import { LinkButtonProps } from "../LinkButton/LinkButton";
import React from "react";

export interface HeadlineSectionProps {
  header?: string;
  title?: string;
  subtitle?: string;
  description?: string;
  button?: LinkButtonProps;
  anchor?: AnchorButtonProps;
}

const HeadlineSection = ({
  header,
  title,
  subtitle,
  description,
  button,
  anchor,
}: HeadlineSectionProps) => {
  return (
    <div className="flex flex-wrap items-center justify-center h-full p-10">
      <div className="max-w-sm text-left">
        {header && <div className="my-4 text-lg font-medium">{header}</div>}
        {title && (
          <div className="max-w-xs my-4 text-5xl font-bold leading-none">
            {title}
          </div>
        )}
        {subtitle && (
          <div className="my-4 text-xs text-gray-200">{subtitle}</div>
        )}
        {description && <div className="my-4">{description}</div>}
        {button && (
          <div className="my-6">
            <LinkButton {...button} />
          </div>
        )}
        {anchor && (
          <div className="my-6">
            <AnchorButton {...anchor} />
          </div>
        )}
      </div>
    </div>
  );
};

export default HeadlineSection;
